module.exports = __webpack_public_path__ + "static/media/carousel5.9faa9bde.gif";